import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
const EASE = [0.23, 1, 0.32, 1] as const;
export function ResearchSection() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="research" className="bg-petrol text-sand py-20 lg:py-28" ref={ref} data-id="element-461" data-mp="3u1kvvrlei0xn">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8" data-id="element-462" data-mp="2tyllg46f07t">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.55,
        ease: EASE
      }} className="max-w-[46rem]" data-id="element-463" data-mp="3kc1cmkts0529">
          <p className="esca-eyebrow text-accent" data-id="element-464" data-mp="gtrar70218do">{c.research.eyebrow}</p>
          <h2 className="esca-h2 mt-5 text-sand text-balance" data-id="element-465" data-mp="llj2hkuy5k5e">
            {c.research.title}
          </h2>
          <p className="esca-lead mt-6 text-petrol-100/70 max-w-[54ch]" data-id="element-466" data-mp="353s0ljctb2av">
            {c.research.lead}
          </p>
        </motion.div>

        {/* Stages */}
        <div className="mt-14 lg:mt-16 relative" data-id="element-467" data-mp="3dv0mvvlleqsz">
          <div className="absolute left-[0.4375rem] top-2 bottom-2 w-px bg-petrol-600 lg:hidden" aria-hidden="true" data-id="element-468" data-mp="3dvtwr5fulwfc" />
          <ol className="grid lg:grid-cols-5 gap-10 lg:gap-6" data-id="element-469" data-mp="3nt8146ohyura">
            {c.research.steps.map((step, i) => <motion.li key={step.title} initial={{
            opacity: 0,
            y: 14
          }} animate={inView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.5,
            delay: 0.2 + i * 0.07,
            ease: EASE
          }} className="relative pl-8 lg:pl-0 lg:pt-8" data-id="element-470" data-mp="3iun0i65c292b" data-mpi={i}>
                <span className="absolute left-0 top-1.5 w-3.5 h-3.5 rounded-full border-2 border-accent bg-petrol lg:top-0 lg:left-0" aria-hidden="true" data-id="element-471" data-mp="1yejt0hmxvyz2" />
                <div className="hidden lg:block absolute left-0 right-0 top-[0.4375rem] h-px bg-petrol-600 -z-0" aria-hidden="true" data-id="element-472" data-mp="6c7d61w6bzoh" />
                <span className="font-display text-sm font-semibold tabular-nums text-accent" data-id="element-473" data-mp="gan4a4v7b8xz">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-2 font-display text-lg lg:text-xl font-semibold text-sand tracking-[-0.02em]" data-id="element-474" data-mp="kafd8ioibh3v">
                  {step.title}
                </h3>
                <p className="mt-2.5 text-[0.9375rem] text-petrol-100/60 leading-relaxed" data-id="element-475" data-mp="u3mg9wvryl0s">
                  {step.text}
                </p>
              </motion.li>)}
          </ol>
        </div>
      </div>
    </section>;
}